import React from "react";
import { Box, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

interface CompanyCardProps {
  icon: React.ReactNode;
  to: string;
  label: string;
  bgColor?: string;
  iconBgColor?: string;
}

const CompanyCard: React.FC<CompanyCardProps> = ({
  icon,
  to,
  label,
  bgColor = "oklch(98.5% 0.001 106.423)",
  iconBgColor,
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        backgroundColor: bgColor,
        borderRadius: "1rem",
        padding: "1rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "1rem",
        width: "250px",
      }}
    >
      <Box sx={{ width: "70px" }}>
        <Box
          sx={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: iconBgColor || theme.palette.grey[400],
          }}
        >
          {icon}
        </Box>
      </Box>
      <Link
        style={{
          color: theme.palette.primary.main,
          textDecoration: "none",
          width: "180px",
        }}
        to={to}
      >
        {label}
      </Link>
    </Box>
  );
};

export default CompanyCard;
